// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K3zH","type":"styles_type__ah1nr","choices":"styles_choices__30A0X"};